import { components, type SingleValueProps } from 'react-select'

import type { PortalReturnLabelDeviceOptionData } from './PortalReturnLabelDeviceOption'

export const PortalReturnLabelDeviceSingleValue = (
  props: SingleValueProps<PortalReturnLabelDeviceOptionData, false>,
) => {
  const { data } = props
  const deviceName = data.returnCase.stocklistItem?.deviceDefinition?.name

  return (
    <components.SingleValue {...props}>{deviceName}</components.SingleValue>
  )
}
